import { React, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useGoogleLogin } from '@react-oauth/google'
import { connect } from 'react-redux'

import { AuthHeader } from 'components/ui/AuthHeader'
import { AuthItem } from 'components/ui/AuthItem'
import { AuthContent } from 'components/ui/AuthContent'
import { AuthRow } from 'components/ui/AuthRow'
import { AuthCol } from 'components/ui/AuthCol'
import { Button } from 'components/ui/Button'
import { BaseLink } from 'components/ui/BaseLink'

import { WhyNeedAccount } from 'components/WhyNeedAccount'
import { FadeCarousel } from 'components/FadeCarousel'

import { authApi, profileApi, callApi } from 'api'

import { setIsPro, logIn } from '../../store/actions'

import img1 from 'i/carousel_images/Influencer.png'
import img2 from 'i/carousel_images/dr-30s-scrubs.png'

const RoleSelect = (props) => {
  const history = useHistory()

  const login = useGoogleLogin({
    scope:
      'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar.events.readonly https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid https://www.googleapis.com/auth/contacts.readonly',
    onSuccess: async (res) => {
      try {
        const loginRes = await authApi.googleLogInPro({
          access_token: res?.access_token,
        })

        if (loginRes?.result?.access_token) {
          props?.setIsPro(true)
          localStorage.setItem('token', loginRes.result.access_token)
          localStorage.setItem('refreshToken', loginRes.result.refresh_token)
          localStorage.setItem('isPro', true)

          await profileApi.setProInfo({
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          })

          const profileRes = await profileApi.getProfileInfo()
          const profile = profileRes?.result?.profile

          const pendingCancelCall = sessionStorage.getItem('pendingCancelCall')
          if (pendingCancelCall) {
            history.push(`/${profile?.channel_name}`)
          } else {
            history.push('/dashboard/pro')
          }

          props?.logIn(profile)
        }

        // Optional import only if we have an OAuth access token for Google APIs.
        if (res?.access_token) {
          const contactsRes = await authApi.getGoogleContacts(res.access_token)
          const contacts = contactsRes?.data?.connections?.filter((e) => e.emailAddresses)
          const emails = contacts?.map((e) => ({
            email: e.emailAddresses[0].value,
            displayName: e.names?.[0]?.displayName || '',
          }))

          await callApi.saveContacts(JSON.stringify(emails))
        }
      } catch (err) {
        console.error('Login or contact fetch failed:', err)
      }
    },
  })

  useEffect(() => {
    document.title = 'TalkPro | Login'
  }, [])

  const items = [
    { image: img1, text: 'Instant Sync with Your Calendar' },
    { image: img2, text: 'Privacy First. No Compromise' },
  ]

  return (
    <AuthRow>
      {/*<AuthCol type="gradient" />*/}
      <AuthCol>
        <FadeCarousel items={items} interval={10000} />
      </AuthCol>
      <AuthCol>
        <AuthHeader title="Login as Pro" offsetMod fadeInMode />
        {/*<AuthItem variant="divider">
          <AuthContent>
            You don’t need to remember an email and password, <br /> plus we’ll send you a
            reminders before your talk
          </AuthContent>
        </AuthItem>*/}
        <AuthItem>
          <AuthContent>
            Everything you need is ready—organized, summarized, and simple to use from the
            moment you log in.
          </AuthContent>
        </AuthItem>
        {/*<AuthItem variant="divider">
          <Button variant="secondary" iconName="google" fullWidth>
            {login && <ProLogin />}
            Continue with Google
          </Button>
        </AuthItem>*/}
        <AuthItem>
          <Button
            variant="tertiary"
            size="lg"
            iconName="google_white"
            fullWidth
            iconTextCenter
            onClick={() => login()}
          >
            Login with Google
          </Button>
        </AuthItem>
        <AuthItem variant="">
          <WhyNeedAccount />
        </AuthItem>
        <AuthItem>
          <BaseLink
            cls="link1"
            href="/pro/join"
            onClick={(e) => {
              e.preventDefault()
              history.push('/pro/join')
            }}
          >
            New to Talkpro? Join here
          </BaseLink>
        </AuthItem>
      </AuthCol>
    </AuthRow>
  )
}

const mapStateToProps = ({ auth: { error } }) => ({
  authError: error,
})

const willMapDispatchToProps = {
  setIsPro,
  logIn,
}

export default connect(mapStateToProps, willMapDispatchToProps)(RoleSelect)
